import styled from 'styled-components';
import { typography, color, system } from 'styled-system';
import { fromTheme } from '../../utils';
import { Box } from '../Box';
import { TypographyVariant } from './Typography.decl';
import { makeEllipsis, makeTypographyVariant, shouldForwardProp } from './utils';
var customProps = system({
  wordBreak: true,
  whiteSpace: true
});
var Typography = styled(Box).withConfig({
  shouldForwardProp: shouldForwardProp
}).withConfig({
  displayName: "Typography",
  componentId: "sc-1ucmpew-0"
})(["font-family:", ";overflow-wrap:break-word;", ";", " ", " ", " ", ""], fromTheme('typography.fontFamily'), makeTypographyVariant, makeEllipsis, typography, color, customProps);
Typography.defaultProps = {
  variant: TypographyVariant.BODY
};
export default Typography;